import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    openCityFormDialog: false,
}

export const headerSlice = createSlice({
    name: 'header/city',
    initialState,
    reducers: {
        setDialogOpen: (state, action) => {
            state.openCityFormDialog = action.payload
        },
    },
})

export const { setDialogOpen } = headerSlice.actions

export default headerSlice.reducer
